import { NgOptimizedImage } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { CwAvatarMenu, CwHeader } from '@bbraun/cortex-angular';
import {
  type CwAvatarMenuCustomEvent,
  type CwAvatarMenuLabel,
  type CwAvatarMenuLink,
} from '@bbraun/cortex-web/dist/components';

import logoUrl from '../../../assets/Logo.svg';
import { AuthService } from '../../../shell/auth/auth.service';
import { ENABLE_STANDALONE_NAVIGATION } from '../../../shell/navigation/standalone-navigation';
import { TranslationService } from '../../../shell/translation-service';

@Component({
  selector: 'ima-main-header',
  imports: [CwHeader, CwAvatarMenu, NgOptimizedImage],
  templateUrl: './main-header.html',
  styleUrl: './main-header.scss',
})
export class MainHeader {
  readonly secondaTittle = input('');
  protected readonly logoUrl = logoUrl;
  protected readonly i18n = inject(TranslationService);
  protected readonly avatarLabels = computed(
    () =>
      ({
        switchOrganisations: this.i18n.t('avatar.switchOrganisations'),
        profileSettings: this.i18n.t('avatar.profileSettings'),
        logout: this.i18n.t('avatar.logout'),
        menuAriaLabel: this.i18n.t('avatar.menu'),
        headerAriaLabel: this.i18n.t('avatar.profile'),
      }) satisfies CwAvatarMenuLabel,
  );

  // cw-avatar-menu's "logout" item is always present. Federated mode still
  // ignores it: the Shell owns its own chrome/logout, and this app has no
  // bearer token to clear anyway.
  private readonly isStandalone = inject(ENABLE_STANDALONE_NAVIGATION, { optional: true }) ?? false;
  private readonly authService = inject(AuthService);

  protected onAvatarMenuNavigate(event: Readonly<CwAvatarMenuCustomEvent<CwAvatarMenuLink>>): void {
    if (this.isStandalone && event.detail === 'logout') {
      void this.authService.logout();
    }
  }
}
